//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Modal, ModalBody, ModalHeader } from 'unison';

import ActionButton from '@components/atoms/action-button/ActionButton';
import { PrimaryButton } from '@components/atoms/button/Button';
import Icon from '@components/atoms/icon/Icon';
import { TitleText } from '@components/atoms/text/Text';
import { actions as streamDrawerActions } from '@streams/actions/streamDrawerActions';
import { AUTO_FILTERS } from '@streams/constants/streamCreationConstants';

import entryImg from 'images/streams-drawer/auto-approve-content-modal-entry.png';

const AutoApprovalEntryModal = () => {
  const dispatch = useDispatch();
  return (
    <AutoApprovalEntryModalWrapper isOpen={true}>
      <AutoApprovalEntryHeader>
        <TitleTextWrapper>Auto Distribute</TitleTextWrapper>
        <ActionButton
          iconName='close'
          onClick={() => {
            dispatch(streamDrawerActions.closeAutoApprovalEntryModal());
          }}
        ></ActionButton>
      </AutoApprovalEntryHeader>
      <AutoApprovalEntryBody>
        <EntryImage>
          <img alt='Auto Distribute Entry Settings Image' src={entryImg} />
        </EntryImage>
        <CreateButton
          onClick={() => {
            dispatch(streamDrawerActions.openAutoApprovalModal());
          }}
        >
          <Icon name='add' /> Create
        </CreateButton>
      </AutoApprovalEntryBody>
    </AutoApprovalEntryModalWrapper>
  );
};

const CreateButton = styled(PrimaryButton)(
  ({ theme }) => `
text-align: center;
margin:${theme.spacings[6]} 0 ${theme.spacings[2]};
width: 115px;
font-weight: normal;
svg {
  fill: none;
  vertical-align: text-bottom;
}
`,
);
const EntryImage = styled.div`
  display: block;
  margin: 0 auto;
`;
const AutoApprovalEntryModalWrapper = styled(Modal)`
  width: ${AUTO_FILTERS.containerWidth}px;
  height: ${AUTO_FILTERS.containerHeight}px;
`;

const AutoApprovalEntryHeader = styled(ModalHeader)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSizes[3]};
`;
const TitleTextWrapper = styled(TitleText)`
  font-size: ${({ theme }) => theme.fontSizes[3]};
`;
const AutoApprovalEntryBody = styled(ModalBody)`
  margin: auto;
  text-align: center;
`;

export default AutoApprovalEntryModal;
